// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__15uiy","label":"Completed_label__VC9if"};